import ThemeSettingsPageView from "./ThemeSettingsPageView";

function ThemeSettingsPage() {
  return <ThemeSettingsPageView />;
}

export default ThemeSettingsPage;
